import styled from 'styled-components';

export const WatchVideoLaterTooltipStyled = styled.div`
    background: var(--color-purple-highlight);
    border: 1px solid var(--color-purple-highlight);
    border-radius: 4px;
    position: relative;
`;

export const WatchVideoLaterImageContainer = styled.div`
    background-image: url('/assets/tutorials/watch-later-hint.png');
    background-size: cover;
    height: 64px;
    width: 213px;
`;

export const WatchVideoLaterMenuTitleStyled = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    left: 33px;
    top: 20px;
`;

export const WatchVideoLaterTooltipFooterStyled = styled.div`
    padding: 12px 16px 16px;
`;
